import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import StudentList from "pages/PrincipalDashboard/student-list/index";
import MasterStudentList from "pages/MasterDashboard/student-list/index";

const mapStateToProps = (state) => {
  return {
    userType: state.user.user_type,
  };
};

export class StudentListMain extends Component {
  render() {
    const userType = this.props.userType;
    if (userType === "teacher") {
      return (
        <div>
          <StudentList />
        </div>
      );
    } else if (userType === "principal") {
      return (
        <div>
          <StudentList />
        </div>
      );
    } else if (userType === "superadmin") {
      return (
        <div>
          <MasterStudentList />
        </div>
      );
    } else {
      return <></>;
    }
  }
}

export default withRouter(connect(mapStateToProps, null)(StudentListMain));
